import React from 'react';
import BadGateway from './BadGateway';
import InternalServerError from './InternalServerError';

const Errors = props => {
  let { statusCode } = props;
  statusCode = parseInt(statusCode, 10);
  if (!statusCode) {
    statusCode = 500;
  }
  return (
    <>
      {statusCode === 500 ? <InternalServerError /> : null}
      {statusCode === 502 ? <BadGateway /> : null}
    </>
  );
};

export default Errors;
